import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { AuthShell } from "@/components/AuthBits";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const [pw, setPw] = useState({ a: "", b: "" });
  const submit = async (e) => {
    e.preventDefault();
    if (pw.a !== pw.b) return toast.error("As senhas não são iguais.");
    try {
      await api.post("/auth/reset-password", { token: sp.get("token"), password: pw.a });
      toast.success("Senha alterada! Faça login.");
      navigate("/entrar");
    } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <AuthShell title="Criar nova senha" backTo="/entrar" forceBack>
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <div><label className="po-label" htmlFor="pa">Nova senha (mínimo 8 caracteres)</label>
          <input id="pa" type="password" minLength={8} required className="po-input" value={pw.a} onChange={(e) => setPw({ ...pw, a: e.target.value })} data-testid="reset-password-input" /></div>
        <div><label className="po-label" htmlFor="pb">Repita a nova senha</label>
          <input id="pb" type="password" minLength={8} required className="po-input" value={pw.b} onChange={(e) => setPw({ ...pw, b: e.target.value })} data-testid="reset-password-confirm-input" /></div>
        <button className="po-btn-primary w-full" data-testid="reset-submit-button">Salvar nova senha</button>
      </form>
    </AuthShell>
  );
}
